'use client'

import Breadcrumb from '@/components/Breadcrumb'
import { useDispatch, useSelector } from '@/hooks/redux'
import { previousPage } from '@/reducers/workflow'
import {
  BackButton,
  TailwindConfig,
  useWindowDimensions
} from '@sedomicilier/material-sd'
import { useTranslations } from 'next-intl'
import { ReactNode } from 'react'

interface MainContentProps {
  children: ReactNode
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  const t = useTranslations('common')
  const dispatch = useDispatch()
  const { path, flow } = useSelector((state) => state.workflow)
  const { width } = useWindowDimensions()
  const workflow = useSelector((state) => state.workflow)

  const hide =
    workflow.path === '/welcome' || workflow.path === '/payment/processing'

  return (
    <main className='flex flex-1 body-1 tablet:px-6 mobile:px-4 tablet:pt-4 pb-4'>
      {width! >= parseInt(TailwindConfig.breakpoints.tablet.min, 10) &&
        !hide && (
          <div className='flex flex-col gap-3 desktop:w-[calc(50%-560px)] desktop:fixed'>
            {path !== flow[0] && (
              <BackButton
                className='w-max'
                label={t('back')}
                size='large'
                onClick={() => dispatch(previousPage())}
              />
            )}
            <Breadcrumb />
          </div>
        )}
      {children}
    </main>
  )
}

export default MainContent
